import Index from '../../pages/servitor/demo/index';
import Help from '../../pages/servitor/demo/help';

const base = 'demo';

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base}/wiki*`,
    name: `${base}-help`,
    component: Help
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/servitor/demo.js